import type { ElementRef, ComponentPropsWithoutRef } from "react";

import { forwardRef } from "react";

const SVGError = forwardRef<ElementRef<"svg">, ComponentPropsWithoutRef<"svg">>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        width="200"
        height="80"
        viewBox="0 0 200 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M30 62.5C32.6667 51.6667 38 29.7 38 28.5H41L50 62.5H30Z"
          fill="none"
        />
        <path
          d="M166.619 59.2633L150.001 51.0396L151.816 42.6846L163.84 48.6585L166.619 59.2633Z"
          fill="currentColor"
          fillOpacity="0.3"
        />
        <path
          d="M161.099 38.1275L153.612 34.4231L154.879 28.5625H158.584L161.099 38.1275Z"
          fill="currentColor"
          fillOpacity="0.3"
        />
        <path
          d="M49.2567 59.2633L32.6392 51.0396L34.454 42.6846L46.4776 48.6585L49.2567 59.2633Z"
          fill="currentColor"
          fillOpacity="0.3"
        />
        <path
          d="M43.7364 38.1275L36.25 34.4231L37.5166 28.5625H41.222L43.7364 38.1275Z"
          fill="currentColor"
          fillOpacity="0.3"
        />
        <path
          d="M123.364 33.7992L121.436 42.8637H115.897L68 19L69.5 13H82.5251L123.364 33.7992Z"
          fill="currentColor"
        />
        <path
          d="M127.75 13.0405L125.822 22.097L107.541 13.0405H127.75Z"
          fill="currentColor"
        />
        <path
          d="M90.0249 42.8258H76.234H62.8682L65.4203 30.6799L90.0249 42.8258Z"
          fill="currentColor"
        />
        <path
          d="M170.135 66.883H144.765V61.1169H170.135V66.883Z"
          fill="currentColor"
        />
        <path
          d="M52.7919 66.883H27.4214V61.1169H52.7919V66.883Z"
          fill="currentColor"
        />
        <path
          d="M170.135 66.883H144.765V61.1169H170.135V66.883Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M166.619 59.2633L150.001 51.0396L151.816 42.6846L163.84 48.6585L166.619 59.2633Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M161.099 38.1275L153.612 34.4231L154.879 28.5625H158.584L161.099 38.1275Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M163.84 48.6586L151.816 42.6846L153.612 34.4231L161.099 38.1275L163.84 48.6586Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M167.091 61.0592H147.827L150.001 51.0396L166.619 59.2633L167.091 61.0592Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M52.7919 66.883H27.4214V61.1169H52.7919V66.883Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M49.2567 59.2633L32.6392 51.0396L34.454 42.6846L46.4776 48.6585L49.2567 59.2633Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.7364 38.1275L36.25 34.4231L37.5166 28.5625H41.222L43.7364 38.1275Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.4777 48.6586L34.4541 42.6846L36.2501 34.4231L43.7365 38.1275L46.4777 48.6586Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M49.7293 61.0592H30.4651L32.6392 51.0396L49.2567 59.2633L49.7293 61.0592Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M69.1636 13.0405L57.7639 66.883"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M139.433 66.883L127.75 13.0405L116.369 66.883"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M121.025 42.8259H62.8682L69.1635 13.0405H83.4179"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M81.0251 13.0405H127.75L121.436 42.8637"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 66.883H194.05"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M65.4204 30.6799L89.525 42.5"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M68.0251 19L115.025 42.5"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M83.5 13.5L123.364 33.7992"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M107.541 13.0405L125.822 22.097"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
SVGError.displayName = "SVGError";

export { SVGError };
